import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { CallTagsSelectors } from 'src/app/store/samwin/call-tags/call-tags.selectors';

@Pipe({
   name: 'translateCallTag',
})
export class TranslateCallTagPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(value: string): string {
      const getReplaceAllTagsInText = this.store.selectSnapshot(CallTagsSelectors.getReplaceAllTagsInText);
      return getReplaceAllTagsInText(value, null, null, null).text;
   }
}
